module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/blackcase_2b86fd.png";